var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col my-8"},_vm._l((_vm.rows),function(row,index){return _c('TimelineRow',{key:index,attrs:{"model":row,"isFirst":index === 0,"isLast":index === _vm.rows.length - 1,"minutesLeft":_vm.minutesLeft}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }